import { useEffect, useState, useRef, useContext} from 'react';
import ChatBody from './ChatBody';
import { AppStateContext } from '../../context/AppStateContext';
import { TabContext } from '../../context/TabContext';

import { FaArrowDown } from "react-icons/fa6";

const ChatPage = ({socket, visible}) => {
    const [messages, setMessages] = useState([]);
    const [typingStatus, setTypingStatus] = useState("");
    const {
        API_URL, 
        teamToken,
        getTeamData, 
        teamData, 
        chatNotification,
        setChatNotification,
        setQuestNotification, 
        currentQuest,
    } = useContext(AppStateContext);
    const lastMessageRef = useRef(null);
    const {activeTab} = useContext(TabContext);

    const firstLoadRef = useRef(false);
    const isProcessingRef = useRef(false);

    const [showScrollBtn, setShowScrollBtn] = useState(false);
    const prevMessagesLengthRef = useRef(0);

    useEffect(() => {
        if (teamData && currentQuest) {
            if(!messages.length) {
                setMessages(teamData.chatHistory);
            }

            if (teamData.chatHistory.length) {
                const lastMessage = teamData.chatHistory[teamData.chatHistory.length - 1];
                
                //raz na wejście bierzemy ostatnią wiadomośc i patrzymy czy jest next_message_id
                if (!firstLoadRef.current) {
                    firstLoadRef.current = true;

                    const timeout = lastMessage.timeout ? lastMessage.timeout * 500 : 1500;
                    
                    setTimeout(async () => {
                        if(lastMessage.next_message_id && !lastMessage.chat_input) {

                            const nextMessage = {
                                id: 'message-next',
                                next_message_id: lastMessage.next_message_id,
                                quest_id: currentQuest.id,
                                team_token: teamToken
                            }
                            socket.emit("message", nextMessage);

                        } else if(lastMessage.next_quest_id) {

                            const nextMessage = {
                                id: 'message-0',
                                next_message_id: 'message-0',
                                quest_id: lastMessage.next_quest_id,
                                team_token: teamToken
                            }
                            socket.emit("message", nextMessage);

                            getTeamData(teamToken);
                            setQuestNotification(true);
                        }
                    }, 3000);
                }

                if(messages.length !== teamData.chatHistory.length) {
                    console.log('messages.length !== teamData.chatHistory.length');
                    setMessages(teamData.chatHistory);
                }
            }

            if(!teamData.chatHistory.length) {
                const nextMessage = {
                    id: 'message-0',
                    next_message_id: 'message-0',
                    quest_id: currentQuest.id,
                    team_token: teamToken
                }
                socket.emit("message", nextMessage);
            }
            
        }
    }, [teamData, currentQuest]);

    useEffect(() => {
        const container = document.querySelector('.message__container');
        if (container) {
            const isAtBottom = container.scrollHeight - container.scrollTop - container.clientHeight < 60;
            if (!isAtBottom) setShowScrollBtn(true);
        }
        prevMessagesLengthRef.current = messages.length;
    }, [messages]);

    useEffect(() => {
        const container = document.querySelector('.message__container');
        if (!container) return;
        const handleScroll = () => {
            const isAtBottom = container.scrollHeight - container.scrollTop - container.clientHeight < 60;
            if (isAtBottom) setShowScrollBtn(false);
        };
        container.addEventListener('scroll', handleScroll);
        return () => container.removeEventListener('scroll', handleScroll);
    }, []);

    function scrollChatView() {
        //lastMessageRef.current?.scrollIntoView({behavior: 'smooth', block: 'end'});

        const messageLastChild = document.querySelector('.message__container').lastChild;
        if(!messageLastChild) return;

        setTimeout(() => {
            document.querySelector('.message__container').scrollTo({
                top: messageLastChild.offsetTop + 500,
                behavior: 'smooth'
            });

        }, 100);
    }

    useEffect(() => {
        //scrollChatView();
    }, [messages]);

    useEffect(() => {
        const handler = data => {
            console.log('Message received:', data);
           // scrollChatView();

            // wiadomości gracza (wybrana odpowiedź) pojawiają się natychmiast,
            // opóźnienie symulujące pisanie dotyczy tylko wiadomości Wiktora
            if (data.name === 'you') {
                setChatNotification({ read: false, message: data });
                return;
            }

            const timeout = data.timeout ? data.timeout * 500 : 1500;

            setTimeout(() => {
                setChatNotification({ read: false, message: data });
            }, timeout);

        };

        socket.on("messageResponse", handler);

    }, []);

    function setMessageAsRead(message) {

            if(message.name !== 'you') {

                console.log('message:: ', message, isProcessingRef.current);

                if(isProcessingRef.current) return;

                isProcessingRef.current = true;

                const timeout = message.timeout ? message.timeout * 500 : 1500;

                // czas "pisania" proporcjonalny do długości tekstu (~8ms/znak),
                // od 1 sek dla krótkich wiadomości do max 2 sek - symuluje pisanie na klawiaturze
                const typingDuration = Math.min(
                    Math.max((message.text?.length || 0) * 8, 1000),
                    2000
                );

                socket.emit("messageRead", { teamToken: teamToken, data: true });

                // wskaźnik "Wiktor pisze..." włącza się dopiero pod koniec oczekiwania,
                // a nie przez cały czas od otrzymania wiadomości
                setTimeout(() => {
                    setTypingStatus("Wiktor pisze ...");
                }, 0);

                setTimeout(async () => {

                    //setMessages(prevMessages => [...prevMessages, message]);

                    isProcessingRef.current = false;

                    setMessages(prevMessages => {
                        const alreadyAdded = prevMessages.some(m => m?.messageKey && m.messageKey === message.messageKey);
                        if (alreadyAdded) {
                            console.log('⚠️ Duplikat wiadomości pominięty:', message.messageKey);
                            return prevMessages;
                        }
                        return [...prevMessages, message];
                    });

                    if(message.next_quest_id) {  
                        const nextMessage = {
                            id: 'message-0',
                            next_message_id: 'message-0',
                            quest_id: message.next_quest_id,
                            team_token: teamToken
                        }
                        socket.emit("message", nextMessage);

                        getTeamData(teamToken);
                        setQuestNotification(true);
                    }

                    setTypingStatus("");

                    if(message.next_message_id && !message.chat_input) {
                        const nextMessage = {
                            id: 'message-next',
                            next_message_id: message.next_message_id,
                            quest_id: currentQuest.id,
                            team_token: teamToken
                        }
                        socket.emit("message", nextMessage);
                    }

                    if(message.show_quest) {
                        setQuestNotification(true);
                    }

                    if(message.go_to_next_quest) {
                        getTeamData(teamToken);
                        setQuestNotification(true);
                    }

                    if(message.sms) {
                        //send SMS
                        await fetch(`${API_URL}/api/sms`, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ message: message.sms.text, sender: message.sms.sender, teamToken: teamToken })
                        });

                    }

                    setChatNotification({ read: true });



                    

                }, timeout + typingDuration);

            } else { //you

                socket.emit("messageRead", { teamToken: teamToken, data: true });

                //bez timeoutu
                //setMessages(prevMessages => [...prevMessages, message]);

                //bez timeoutu
                setMessages(prevMessages => {
                    const alreadyAdded = prevMessages.some(m => m?.messageKey && m.messageKey === message.messageKey);
                    if (alreadyAdded) {
                        console.log('⚠️ Duplikat wiadomości pominięty:', message.messageKey);
                        return prevMessages;
                    }
                    return [...prevMessages, message];
                });

                if(message.next_message_id) {
                    const nextMessage = {
                        id: 'message-next',
                        next_message_id: message.next_message_id,
                        quest_id: currentQuest.id,
                        team_token: teamToken
                    }
                    socket.emit("message", nextMessage);
                }

                setChatNotification({ read: true });

            }

            
           // scrollChatView();
            
    }

    useEffect(() => {
            
        //jesteśmy na zakładce z czatem
        if(activeTab === 'chat') {

            // jeśli wiadomość jest przeczytana
            if((chatNotification && chatNotification.read) || !chatNotification) {
                return;
            }

            // ustaw wiadomość jako przeczytaną
            if(chatNotification && !chatNotification.message) {
                setChatNotification({ read: true });

                return;
            }

            if(chatNotification.message.name !== 'you') {
                //isProcessingRef.current = true;
                setMessageAsRead(chatNotification.message);
            }
            
        }

        // ustawiamy wiadomość od razu jako przeczytaną jeśli to jest wiadomość z wybraną sugestią przez nas
        if(chatNotification && chatNotification.message && chatNotification.message.name === 'you') {
            setMessageAsRead(chatNotification.message);
        }
    

    }, [chatNotification, activeTab]);

    useEffect(() => {
        if (activeTab !== 'chat') return;
        const container = document.querySelector('.message__container');
        if (!container) return;
        const isAtBottom = container.scrollHeight - container.scrollTop - container.clientHeight < 60;
        if (!isAtBottom) setShowScrollBtn(true);
    }, [activeTab]);

    useEffect(()=> {
        socket.on("typingResponse", data => setTypingStatus(data));
    }, [socket]);

    return (
        <div className={`chat__main ${visible ? '-visible' : '-hide'}`} style={{position: 'relative'}}>
              
            <ChatBody
                socket={socket}
                messages={messages} 
                typingStatus={typingStatus} 
                lastMessageRef={lastMessageRef}
            />

            {showScrollBtn && (
                <button
                    className="scroll-to-bottom-btn"
                    onClick={() => { scrollChatView(); setShowScrollBtn(false); }}
                    style={{
                        position: 'absolute',
                        bottom: '20px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        background: '#037ffc',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '50%',
                        width: '30px',
                        height: '30px',
                        fontSize: '16px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 10,
                        bottom: '36px'
                    }}
                >
                    <FaArrowDown />
                </button>
            )}
        </div>

    );
};

export default ChatPage;
